export default function install(Vue) {
  //数据权限
  (Vue.prototype.dataAccess = [
    {
      name: "机构",
      value: "1",
    },
    {
      name: "部门",
      value: "2",
    },
    {
      name: "用户",
      value: "3",
    },
  ]),
    //机构类型
    (Vue.prototype.institutionalType = [
      {
        name: "平台",
        value: "pf",
      },
      {
        name: "企业",
        value: "com",
      },
      {
        name: "团队",
        value: "team",
      },
      {
        name: "其他",
        value: "other",
      },
    ]),
    //证件类型
    (Vue.prototype.identityType = [
      {
        name: "身份证",
        value: "sfz",
      },
      {
        name: "护照",
        value: "hz",
      },
      {
        name: "港澳居民来往内地通行证",
        value: "txz",
      },
      {
        name: "台湾居民来往大陆通行证",
        value: "tw",
      },
      {
        name: "外国人永久居留身份证",
        value: "waiguoren",
      },
      {
        name: "港澳台居民居住证",
        value: "hkmojumin",
      },
    ]),
    //员工类型
    (Vue.prototype.staffType = [
      {
        name: "公司人员",
        value: "gs",
      },
      {
        name: "外聘人员",
        value: "wp",
      },
    ]),
    //员工状态
    (Vue.prototype.staffname = [
      {
        name: "实习",
        value: "sx",
      },
      {
        name: "试用",
        value: "sy",
      },
      {
        name: "正式",
        value: "zs",
      },
      {
        name: "离岗",
        value: "lg",
      },
      {
        name: "离职",
        value: "lz",
      },
      {
        name: "退休",
        value: "tx",
      },
    ]),

    //生育状态
    (Vue.prototype.fertilityname = [
      {
        name: "未育",
        value: "false",
      },
      {
        name: "已育",
        value: "true",
      },
    ]),
    //婚姻状态
    (Vue.prototype.maritalStatus = [
      {
        name: "已婚",
        value: "married",
      },
      {
        name: "未婚",
        value: "unmarried",
      },
    ]),
    //物资属性状态
    (Vue.prototype.maritalList = [
      {
        name: "易耗品",
        value: "yhp",
      },
      {
        name: "固定资产",
        value: "gdzc",
      },
    ]),
    //性别
    (Vue.prototype.genderMsg = [
      {
        name: "女",
        value: "fm",
      },
      {
        name: "男",
        value: "m",
      },
    ]),
    //签到类型
    (Vue.prototype.punchResultData = [
      {
        name: "签到",
        value: "sign_in",
      },
      {
        name: "签退",
        value: "sign_out",
      },
      {
        name: "迟到",
        value: "late",
      },
      {
        name: "早退",
        value: "early",
      },
      {
        name: "无效",
        value: "invalid",
      },
    ]),
    //签到状态
    (Vue.prototype.punchStateData = [
      {
        name: "正常",
        value: "true",
      },
      {
        name: "不正常",
        value: "false",
      },
    ]),
    //内外业
    (Vue.prototype.inOutDoor = [
      {
        name: "外业",
        value: "true",
      },
      {
        name: "内业",
        value: "false",
      },
    ]),
    //印章归属
    (Vue.prototype.sealBelongto = [
      {
        name: "公司",
        value: "gs",
      },
      {
        name: "个人",
        value: "gr",
      },
    ]);
  //学历
  Vue.prototype.eduLevel = [
    {
      name: "专科",
      value: "zk",
    },
    {
      name: "本科",
      value: "bk",
    },
    {
      name: "硕士",
      value: "ss",
    },
    {
      name: "博士",
      value: "bs",
    },
  ];
  Vue.prototype.verifyStatus = [
    {
      value: "hold",
      name: "等待提交流程",
    },
    {
      value: "pending",
      name: "待审批",
    },
    {
      value: "doing",
      name: "审批中",
    },
    {
      value: "deny",
      name: "拒绝",
    },
    {
      value: "pass",
      name: "通过",
    },
  ];
  // 款项类型
  Vue.prototype.typeStatus = [
    {
      value: "jk",
      name: "借款",
    },
    {
      value: "bx",
      name: "报销",
    },
    {
      value: "bzj",
      name: "保证金",
    },
    {
      value: "zj",
      name: "资金",
    },
    {
      value: "fk",
      name: "付款",
    },
  ];
  //月份
  Vue.prototype.monthMsg = [
    {
      value: "01",
      name: "一月",
    },
    {
      value: "02",
      name: "二月",
    },
    {
      value: "03",
      name: "三月",
    },
    {
      value: "04",
      name: "四月",
    },
    {
      value: "05",
      name: "五月",
    },
    {
      value: "06",
      name: "六月",
    },
    {
      value: "07",
      name: "七月",
    },
    {
      value: "08",
      name: "八月",
    },
    {
      value: "09",
      name: "九月",
    },
    {
      value: "10",
      name: "十月",
    },
    {
      value: "11",
      name: "十一月",
    },
    {
      value: "12",
      name: "十二月",
    },
  ];
  //活动类型
  Vue.prototype.activityType = [
    {
      name: "问卷",
      value: "qa",
    },
    {
      name: "测试",
      value: "test",
    },
    {
      name: "报名",
      value: "signUp",
    },
  ];
  // 问题类型
  Vue.prototype.questionType = [
    {
      name: "输入",
      value: "sr",
    },
    {
      name: "选择",
      value: "xz",
    },
    {
      name: "打分",
      value: "df",
    },
    {
      name: "附件",
      value: "fj",
    },
  ];
  // 输入问题类型
  Vue.prototype.questionInputType = [
    {
      name: "不限",
      value: "none",
    },
    {
      name: "手机",
      value: "phone",
    },
    {
      name: "邮箱",
      value: "email",
    },
    {
      name: "数字",
      value: "number",
    },
    {
      name: "字母",
      value: "word",
    },
    {
      name: "汉字",
      value: "hanzi",
    },
  ];
  // 选择题类型
  Vue.prototype.choiceQuestionType = [
    {
      name: "下拉",
      value: "select",
    },
    {
      name: "展开",
      value: "check",
    },
  ];
  // 输入框大小
  Vue.prototype.inputSizeType = [
    {
      name: "小",
      value: "小",
    },
    {
      name: "中",
      value: "中",
    },
    {
      name: "大",
      value: "大",
    },
  ];
  // 通知管理-内容类型选择数组
  Vue.prototype.contentTypeList = [
    {
      name: "富文本",
      value: "text",
    },
    {
      name: "链接",
      value: "url",
    },
  ];
  // 通知管理-通知范围选择数组
  Vue.prototype.rangeList = [
    {
      name: "系统（全系统人员）",
      value: "sys",
    },
    {
      name: "机构",
      value: "org",
    },
    {
      name: "部门",
      value: "dept",
    },
    {
      name: "个人",
      value: "user",
    },
  ];
  // 打卡状态选择数组
  Vue.prototype.punchResultList = [
    {
      name: "签到",
      value: "sign_in",
    },
    {
      name: "签退",
      value: "sign_out",
    },
    {
      name: "迟到",
      value: "late",
    },
    {
      name: "早退",
      value: "early",
    },
    {
      name: "无效",
      value: "invalid",
    },
  ];
  // 打卡状态选择数组
  Vue.prototype.punchTypeList = [
    {
      name: "签到",
      value: "qd",
    },
    {
      name: "补卡",
      value: "bk",
    },
  ];
  //固定资产领用归还状态
  Vue.prototype.fixedMaterialState = [
    { name: "待归回", value: "false" },
    { name: "已归回", value: "true" },
  ];
  //项目状态
  Vue.prototype.projectStateData = [
    { name: "未启动", value: "wqd" },
    { name: "启动", value: "qd" },
    { name: "暂停", value: "zt" },
    { name: "办结", value: "bj" },
    { name: "作废", value: "zf" },
  ];
  //项目类型
  Vue.prototype.projectTypeData = [
    { name: "行政管理", value: "xzgl" },
    { name: "承接项目（乙方）", value: "cjxm" },
    { name: "委托项目（甲方）", value: "wtxm" },
    { name: "合作项目", value: "hzxm " },
  ];
  //物资属性
  Vue.prototype.materialNatureData = [
    { name: "易耗品", value: "yhp" },
    { name: "固定资产", value: "gdzc" },
  ];
  //招标方式
  Vue.prototype.tenderModeData = [
    { name: "邀标", value: "yb" },
    { name: "公开", value: "gk" },
    { name: "询价", value: "xj" },
    { name: "网上竞标", value: "wsjb" },
  ];
  //是否领取通知书
  Vue.prototype.isReceiveData = [
    { name: "是", value: "true" },
    { name: "否", value: "false" },
  ];
  //投标状态
  Vue.prototype.bidStatusData = [
    { name: "未开标", value: "unopen" },
    { name: "中标", value: "win" },
    { name: "流标", value: "failure" },
    { name: "废标", value: "cancel" },
    { name: "终止招标", value: "suspend " },
    { name: "其他", value: "other" },
  ];
  // 考勤设置类型：am，上午；pm，下午；all，全天
  Vue.prototype.attendanceType = [
    { name: "上午", value: "am" },
    { name: "下午", value: "pm" },
    { name: "全天", value: "all" },
  ];
  //付款方式
  Vue.prototype.paymentWaysData = [
    {
      name: "现金",
      value: "xj",
    },
    {
      name: "转账",
      value: "zz",
    },
    {
      name: "汇票",
      value: "hp",
    },
    {
      name: "保函",
      value: "bh",
    },
  ];
      //保证金类型
Vue.prototype.marginType = [
    {
      name: "投标保证金",
      value: "tb",
    },
    {
      name: "履约保证金",
      value: "ly",
    },
    {
      name: "履约保函保证金",
      value: "ly_bh",
    },
    {
      name: "预付款保函保证金",
      value: "yfk_bh",
    },
  ]
}
//export default dict
